export enum EvaluatorOffice {
  "Baguio City Police Office - BCPO" = "BCPO",
  "City Health Services Office - CHSO" = "CHSO",
  "Public Employment Service Office - PESO" = "PESO",
  "City Mayor's Office - CMO" = "CMO",
}
